import { createRef } from 'react'
import { CustomRouteObject } from 'react-router-dom'

import { routeNamesPaths } from '@shared/constants'

export const SubFundPageRouter: CustomRouteObject = {
  path: routeNamesPaths.subFund,
  lazy: async () => {
    const { SubFundPage } = await import('./ui')

    return {
      Component: SubFundPage,
    }
  },
  nodeRef: createRef(),
}
